import { connect } from "react-redux";
import * as factoringActions from "./factoring/actions";
import * as smeActions from "./sme/actions";
import * as originatorActions from "./originator/actions";

function mapStateToProps(state) {
  return {
    marketplace: state.marketplace,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    createFactoring: (postData) => {
      dispatch(factoringActions.create_factoring(postData));
    },
    changeFactoringListPage: (page) => {
      dispatch(factoringActions.change_factoring_list_page(page));
    },
    changeFactoringListFilter: (key, value) => {
      dispatch(factoringActions.change_factoring_list_filter(key, value));
    },
    getFactoringApplications: () => {
      dispatch(factoringActions.get_factoring_applications());
    },
    // SME
    createSME: (postData) => {
      dispatch(smeActions.create_sme(postData));
    },
    changeSMEListPage: (page) => {
      dispatch(smeActions.change_sme_list_page(page));
    },
    changeSMEListFilter: (key, value) => {
      dispatch(smeActions.change_sme_list_filter(key, value));
    },
    getSMEApplications: () => {
      dispatch(smeActions.get_sme_applications());
    },
    // ORIGINATORS
    getOriginators: () => {
      dispatch(originatorActions.get_originators());
    },
  };
}

export const marketplaceConnector = connect(
  mapStateToProps,
  mapDispatchToProps,
);
